<template>
    <div class="login">
        <form class="login__form" @submit.prevent="login">
            <h3 class="title">
                {{ $t('adminPanel') }}
            </h3>

            <div class="login__form-body">
                <BaseInput
                    v-model="credentials.login"
                    name="login"
                    class="input__login"
                    aria-label="login-input"
                    autocomplete="login"
                    :placeholder="$t('placeholder.login')"
                    :has-error="validate.login.$error"
                    :error-msg="$t('error.required')"
                    focus-on-mounted
                    @blur="validate.login.$touch"
                />

                <PasswordInput
                    v-model="credentials.password"
                    name="password"
                    aria-label="password-input"
                    class="input__password"
                    :placeholder="$t('placeholder.password')"
                    :has-error="validate.password.$error"
                    :error-msg="$t('error.required')"
                    @blur="validate.password.$touch"
                />
            </div>

            <div class="login__form-bottom">
                <SimpleButton
                    type="submit"
                    aria-label="Sign in"
                    class="submit-button"
                    :loading="loading"
                    :text="$t('button.signIn')"
                    :disabled="validate.$invalid"
                />
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'LoginLayout',
};
</script>

<script setup>
import { reactive, ref } from 'vue';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { UserService } from '@/services/user-service';
import SimpleButton from '@/components/ui/buttons/SimpleButton';
import BaseInput from '@/components/ui/inputs/BaseInput/index.vue';
import PasswordInput from '@/components/ui/inputs/PasswordInput';

const emit = defineEmits(['get-me']);

const loading = ref(false);

const credentials = reactive({
    login: '',
    password: '',
});

const rules = {
    login: { required },
    password: { required },
};

const validate = useVuelidate(rules, credentials);

const login = async () => {
    loading.value = true;

    const body = {
        login: credentials.login.trim(),
        password: credentials.password.trim(),
    };
    const resp = await UserService.logIn(body);

    loading.value = false;
    if (!resp) return;
    emit('get-me');
};
</script>

<style src="./styles.scss" lang='scss' scoped />
